import { mapValues } from '@exodus/basic-utils';
export const createDependencyId = ({ id, optional }) => optional ? `${id}?` : id;
export const namespaceLogger = ({ logger, namespace, }) => {
    return mapValues(logger, (log) => (...args) => log(`[${namespace}]`, ...args));
};
const isPromise = (value) => {
    return Boolean(value && typeof value === 'object' && typeof value.finally === 'function');
};
export const createPerformanceProxy = ({ object, now, threshold, onAboveThreshold, }) => {
    return new Proxy(object, {
        get(target, prop) {
            const value = Reflect.get(target, prop);
            if (typeof value !== 'function') {
                return value;
            }
            return (...args) => {
                const start = now();
                let async = false;
                const maybeNotify = () => {
                    const duration = now() - start;
                    if (duration < threshold)
                        return;
                    onAboveThreshold({ method: prop, duration, async });
                };
                try {
                    const returnValue = value.apply(target, args);
                    if (!isPromise(returnValue)) {
                        return returnValue;
                    }
                    async = true;
                    return returnValue.finally(() => {
                        maybeNotify();
                    });
                }
                finally {
                    if (!async) {
                        maybeNotify();
                    }
                }
            };
        },
    });
};
